import styled, { css } from "styled-components";
import { TextStyleSheetProps } from "../@types/text";
import { getColor } from "../../../utils/color";

const h1 = css`
  font-weight: 600;
  font-size: 56px;
`;

const h2 = css`
  font-weight: 600;
  font-size: 42px;
`;

const h3 = css`
  font-weight: 600;
  font-size: 30px;
`;

const h4 = css`
  font-size: 16px;
  font-weight: 500;
`;

const h5 = css`
  font-size: 16px;
  font-weight: 400;
`;

const h6 = css`
  font-size: 14px;
  font-weight: 400;
`;

const p = css`
  font-size: 16px;
`;

const span = css`
  font-size: 1rem;
`;

const styles = {
  span,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6
};

export const TextStyleSheet = styled.span.attrs<
  TextStyleSheetProps,
  TextStyleSheetProps
>((props) => ({
  ...props,
  color: props.color || "#fafafa",
}))`
  color: ${({ color }) => getColor(color).main} !important;

  ${({ like }) => like && styles[like]};
  ${({ strong, color }) =>
    strong &&
    css`
      font-weight: 800;
      color: ${getColor(color).main} !important;
    `};

  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ align }) => align && `text-align: ${align};`};
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight};`}
  ${({ visibility }) => visibility && `visibility: ${visibility};`};
  ${({ transform }) => transform && `text-transform: ${transform};`};
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px;`};
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}px;`};
  ${({ space }) => space && `letter-spacing: ${space}px;`};
  ${({ whiteSpace }) => whiteSpace && `white-space: ${whiteSpace};`};
  ${({ decoration }) => decoration && `text-decoration: ${decoration};`}

`;
